// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2d7e5052","643":"5dd85292","787":"1daac557","821":"3b744e04"}[chunkId] + ".chunk.js";
};